/**
 * Product Ritual [New] — scroll reveals (Framer whileInView parity)
 * EASE: cubic-bezier(0.22, 1, 0.36, 1)
 *
 * data-pr-reveal
 * data-pr-reveal-y                     (px)
 * data-pr-reveal-dur                   (seconds)
 * data-pr-reveal-delay                 (ms)
 * data-pr-reveal-margin                (e.g. -100px)
 */
(function () {
  'use strict';

  var SECTION_TYPE = 'product-ritual-new';

  function prefersReduced() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function applyVars(el) {
    var y = el.getAttribute('data-pr-reveal-y');
    var dur = el.getAttribute('data-pr-reveal-dur');
    var delay = el.getAttribute('data-pr-reveal-delay');
    if (y != null && y !== '') el.style.setProperty('--pr-y', y + 'px');
    if (dur != null && dur !== '') el.style.setProperty('--pr-dur', dur + 's');
    if (delay != null && delay !== '') el.style.setProperty('--pr-delay', delay + 'ms');
  }

  function init(root) {
    if (!root || root.dataset.vgPrInit) return;
    root.dataset.vgPrInit = '1';

    var nodes = root.querySelectorAll('[data-pr-reveal]');
    if (!nodes.length) return;

    if (prefersReduced() || typeof IntersectionObserver === 'undefined') {
      nodes.forEach(function (el) {
        el.classList.add('is-inview');
      });
      return;
    }

    nodes.forEach(applyVars);

    var groups = {};
    nodes.forEach(function (el) {
      var margin = el.getAttribute('data-pr-reveal-margin') || '-100px';
      if (!groups[margin]) groups[margin] = [];
      groups[margin].push(el);
    });

    Object.keys(groups).forEach(function (marginY) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-inview');
            observer.unobserve(entry.target);
          });
        },
        {
          root: null,
          rootMargin: marginY + ' 0px',
          threshold: 0,
        }
      );
      groups[marginY].forEach(function (el) {
        observer.observe(el);
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-section-type="' + SECTION_TYPE + '"]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (evt) {
    var root =
      evt.target &&
      (evt.target.querySelector
        ? evt.target.querySelector('[data-section-type="' + SECTION_TYPE + '"]')
        : null);
    if (!root && evt.target && evt.target.matches) {
      root = evt.target.matches('[data-section-type="' + SECTION_TYPE + '"]') ? evt.target : null;
    }
    if (root) {
      delete root.dataset.vgPrInit;
      init(root);
    }
  });
})();
